module.exports = __webpack_public_path__ + "img/mortarboard-def-icon.6ff2e7b0.svg";